import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  fonts: {
    heading: `'Roxborough CF', serif`,
    body: `'Montserrat', sans-serif`,
  },
  styles: {
    global: {
      "input:-webkit-autofill": {
        boxShadow: "0 0 0px 1000px #F2EEE8 inset !important",
        WebkitBoxShadow: "0 0 0px 1000px #F2EEE8 inset !important",
        WebkitTextFillColor: "inherit",
      },
      body: {
        bg: "#fff",
        color: "black",
        fontFamily: "body", // which is Roxborough CF now
      },
    },
  },
  components: {
    Heading: {
      baseStyle: {
        fontFamily: "heading",
      },
    },
    Text: {
      baseStyle: {
        fontFamily: "body",
      },
    },
  },
});

export default theme;
